module.exports = __webpack_public_path__ + "img/featureBackground2.2985cb16.png";